import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-user-agent",
  templateUrl: "./user-agent.component.html",
})
export class UserAgentComponent {
  @Input() public raw: string;
  @Input() public info: any;
}
